module.exports = __webpack_public_path__ + "img/王称堌镇.838da58a.png";